import React from 'react';
import SalesReportsHeader from '../SalesReportsHeader';
import SalesReportsContent from '../SalesReportsContent';

const SalesReports = () => {
    return (
        <>
            <SalesReportsHeader />
            <SalesReportsContent />
        </>
    );
};

export default SalesReports;
